import React, { useState } from 'react';
import { IconButton, Tooltip, Popover, Typography, Box } from '@mui/material';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import CloseIcon from '@mui/icons-material/Close';

interface InfoButtonProps {
  title: string;
  content: string;
}

export const InfoButton: React.FC<InfoButtonProps> = ({ title, content }) => {
  const [anchorEl, setAnchorEl] = useState<HTMLButtonElement | null>(null);

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    event.stopPropagation(); // Prevent event bubbling to parent container
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleCloseClick = (event: React.MouseEvent) => {
    event.stopPropagation(); // Prevent event bubbling to parent container
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);

  return (
    <>
      <Tooltip title="Information">
        <IconButton
          size="small"
          onClick={handleClick}
          onMouseDown={(e) => e.stopPropagation()} // Also stop mousedown events
          sx={{ ml: 1, opacity: 0.6, '&:hover': { opacity: 1 } }}
        >
          <InfoOutlinedIcon fontSize="small" />
        </IconButton>
      </Tooltip>
      <Popover
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'left',
        }}
        disableAutoFocus
        disableEnforceFocus
      >
        <Box sx={{ p: 2, maxWidth: 300, position: 'relative' }}>
          <IconButton
            size="small"
            onClick={handleCloseClick}
            onMouseDown={(e) => e.stopPropagation()} // Also stop mousedown events
            sx={{
              position: 'absolute',
              right: 4,
              top: 4,
              color: 'text.secondary'
            }}
          >
            <CloseIcon fontSize="small" />
          </IconButton>
          <Typography variant="subtitle2" sx={{ fontWeight: 'bold', mb: 1, pr: 3 }}>
            {title}
          </Typography>
          <Typography variant="body2" color="text.secondary">
            {content}
          </Typography>
        </Box>
      </Popover>
    </>
  );
};
